import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.54 29.183H2.613a2.58 2.58 0 00-2.581 2.581 2.579 2.579 0 002.581 2.581H32.01c.03 0 .06 0 .09-.03.061 0 .092 0 .153-.03.03 0 .09-.03.121-.03.03 0 .091-.031.121-.031s.092-.03.122-.03.091-.03.121-.03c.03-.031.061-.031.122-.062.03-.03.09-.03.121-.06.03-.03.061-.03.091-.061.03-.03.061-.03.122-.06.03-.031.06-.062.121-.092.03-.03.061-.03.091-.06l.365-.365c.03-.03.03-.06.06-.091a.42.42 0 00.092-.122c.03-.03.03-.06.06-.121.03-.03.03-.06.061-.122.03-.03.03-.09.06-.121.031-.03.031-.06.062-.121.03-.03.03-.061.03-.122 0-.03.03-.091.03-.121s.03-.092.03-.122.031-.091.031-.121 0-.091.03-.122c0-.03 0-.09.03-.121V2.58A2.579 2.579 0 0031.767 0c-1.428.03-2.582 1.184-2.582 2.612v22.927L4.587.94A2.527 2.527 0 002.765.182c-.668 0-1.306.243-1.822.76a2.584 2.584 0 000 3.643L25.54 29.183zM29.183 60.158v22.927a2.579 2.579 0 002.581 2.581 2.579 2.579 0 002.581-2.581V53.932v-.243c0-.03 0-.06-.03-.09 0-.061 0-.092-.03-.153 0-.03-.03-.09-.03-.121 0-.03-.031-.091-.031-.122 0-.03-.03-.09-.03-.121 0-.03-.03-.091-.03-.121-.031-.03-.031-.061-.062-.122-.03-.03-.03-.091-.06-.121s-.03-.061-.061-.092c-.03-.03-.03-.06-.06-.121a.418.418 0 01-.092-.121c-.03-.03-.03-.061-.06-.092l-.365-.364c-.03-.03-.06-.03-.091-.06a.42.42 0 00-.122-.092c-.03-.03-.06-.03-.121-.06-.03-.03-.06-.03-.122-.061-.03-.03-.09-.03-.121-.061-.03-.03-.06-.03-.121-.06-.03-.031-.061-.031-.122-.031-.03 0-.091-.03-.121-.03s-.092-.03-.122-.03-.091-.031-.121-.031-.091 0-.122-.03c-.03 0-.09 0-.121-.03H2.58A2.579 2.579 0 000 53.931a2.58 2.58 0 002.581 2.581H25.54L.94 81.112a2.527 2.527 0 00-.759 1.822c0 .668.243 1.336.76 1.822a2.584 2.584 0 003.643 0l24.598-24.597zM60.461 56.514h22.927a2.579 2.579 0 002.581-2.582 2.579 2.579 0 00-2.58-2.58H53.992c-.03 0-.06 0-.091.03-.061 0-.091 0-.152.03-.03 0-.091.03-.122.03-.03 0-.09.03-.121.03-.03 0-.091.03-.121.03s-.092.031-.122.031c-.03.03-.06.03-.122.061-.03.03-.09.03-.12.06-.031.031-.062.031-.092.061s-.06.03-.121.061c-.03.03-.061.06-.122.091-.03.03-.06.03-.091.061l-.364.364c-.03.03-.03.061-.061.092-.03.03-.061.06-.091.121-.03.03-.03.06-.061.121-.03.03-.03.061-.06.122-.031.03-.031.091-.062.121-.03.03-.03.061-.06.122-.03.03-.03.06-.03.121 0 .03-.031.091-.031.122 0 .03-.03.09-.03.121 0 .03-.03.091-.03.122 0 .03 0 .09-.031.121 0 .03 0 .091-.03.122v29.395a2.58 2.58 0 002.58 2.581 2.579 2.579 0 002.582-2.58V60.157l24.597 24.597c.517.516 1.154.76 1.823.76.668 0 1.336-.244 1.822-.76a2.584 2.584 0 000-3.644L60.46 56.513zM56.817 25.539V2.61a2.58 2.58 0 00-2.581-2.58 2.58 2.58 0 00-2.581 2.58V32.007c0 .03 0 .06.03.091 0 .06 0 .091.03.152 0 .03.03.091.03.121s.031.091.031.122c0 .03.03.091.03.121s.03.091.03.122c.031.03.031.06.062.121.03.03.03.091.06.122.03.03.03.06.06.09.031.031.031.062.062.122.03.03.06.061.09.122.031.03.031.06.061.09l.365.365c.03.03.06.03.091.061.03.03.06.06.122.091.03.03.06.03.121.06.03.031.06.031.121.062.03.03.091.03.122.06.03.03.06.03.121.061.03.03.061.03.122.03.03 0 .09.03.121.03.03 0 .091.031.122.031.03 0 .09.03.121.03.03 0 .091 0 .122.03.03 0 .09 0 .121.031H83.42a2.579 2.579 0 002.58-2.581 2.58 2.58 0 00-2.58-2.581H60.46L85.058 4.585c.517-.516.76-1.154.76-1.822 0-.668-.243-1.336-.76-1.822a2.584 2.584 0 00-3.644 0L56.817 25.54z"
        fill={props.color || '#000'}
      />
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgMinimize = _style(SvgIcon)

export default SvgMinimize
